import _ = require("underscore");
import Utils = require("../utils");
import Portal = require("portal-gis");
import Base = require("./base-command");
import ol = require("ol");

const feetPerMeter = 3.2808399;
const feetPerMile = 5280;
const metersPerAcre = 63.6149353533; // if an acre were a linear units

const uom = {
    units: {
        meters: 1,
        kilometers: 0.001,
        centimeters: 100,
        millimeters: 1000,
        miles: feetPerMeter / feetPerMile,
        acres: 1 / metersPerAcre,
        feet: feetPerMeter,
        yards: feetPerMeter / 3,
        inches: 12 * feetPerMeter,
        pixels: 3779.52
    }
};

uom.units["m"] = uom.units.meters;
uom.units["km"] = uom.units.kilometers;
uom.units["ft"] = uom.units.feet;
uom.units["mi"] = uom.units.miles;

function convert(unit: {
    dimensions: number;
    units: string;
    value: number;
}, target = "meters") {
    let scale = Math.pow(uom.units[target] / uom.units[unit.units], unit.dimensions);
    let value = scale * unit.value;
    return {
        dimensions: unit.dimensions,
        units: target,
        value: value
    };
}

class Handler extends Base<{
    out: {
        feature: ol.Feature,
        measurement: {
            dimensions: number;
            units: string;
            value: number
        }
        final: boolean;
    }
}> {

    static about = `Converts a measurement`;

    static options = {
        "autoformat": {
            "about": "automatically convert to larger units (ft->mi, m->km)",
            "default": "true"
        },
        "default-uom": {
            "about": "Unit of measure to use when rendering measurements",
            "domain": "english|metric|meters",
            "default": "metric"
        },
        "geodesic": {
            "about": "Use geodesic",
            "default": "true"
        },
        "symbology": {
            "about": "Symbology to use when rendering measurements",
            "default": "measurements"
        },
    }

    static DEFAULT_OPTIONS = {
        "default-uom": "metric",
        "geodesic": "true",
        "symbology": "measurements",
        "autoformat": "true"
    }

    execute(args = this.args) {

        let options = _.defaults(this.options, Handler.DEFAULT_OPTIONS);

        let unit = convert(args.out.measurement, "m");

        Utils.ifOption(options, "default-uom", uom => {
            switch (uom) {
                case "english":
                    unit = convert(unit, "ft");
                    break;
                case "metric":
                    break;
                case "meters":
                    unit = convert(unit, "m");
                    break;
            }
        });

        if (options["autoformat"] !== "false") {
            if (unit.value > 10000) {
                switch (unit.units) {
                    case "m":
                        unit = convert(unit, "km");
                        unit.value = parseFloat(unit.value.toFixed(2));
                        break;
                    case "ft":
                        unit = convert(unit, unit.dimensions === 1 ? "mi" : "acres");
                        if (unit.value > 10000) {
                            unit = convert(unit, "mi");
                        }
                        unit.value = parseFloat(unit.value.toFixed(2));
                        break;
                }
            } else {
                unit.value = parseFloat(unit.value.toFixed(0));
            }
        }

        let labelText: string;
        switch (unit.dimensions) {
            case 1:
                labelText = `${unit.value} ${unit.units}`;
                break;
            case 2:
                if (unit.units === "acres") {
                    labelText = `${unit.value} ${unit.units}`;
                } else {
                    labelText = `${unit.value} ${unit.units}^${unit.dimensions}`;
                }
                break;
            default:
                labelText = `${unit.value} ${unit.units}^${unit.dimensions}`;
                break;
        }

        console.log("measurement:", labelText);
        let style = args.out.feature.getStyle();
        if (style) {
            if (!style.length) style = [style];
            let text = style.filter(s => !!s.getText && !!s.getText())[0];
            if (text) {
                text.getText().setText(labelText);
                // force a refresh?
                args.out.feature.setStyle(style);
            }
        }
    }
}

export = Handler;